<template>
  <TransitionGroup name="fade" tag="div" id="container">
    <Alert
      class="w-full max-w-md block"
      v-for="flashAlert in store.flashAlerts.values()"
      :key="flashAlert.id"
      :tone="flashAlert.tone"
      :on-close="() => flashAlertsManager.close(flashAlert.id)"
      dismissible
      v-bind="$attrs"
    >
      {{ flashAlert.message }}
    </Alert>
  </TransitionGroup>
</template>

<script setup lang="ts">
import { Alert } from "prism";
import { useEditorStore } from "@/stores/editor_store";
import { useFlashAlertsManager } from "@/composables/flash_alerts_manager";

const { flashAlertsManager } = useFlashAlertsManager();
const store = useEditorStore();
</script>

<style scoped>
.fade-move,
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

#container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
